export const LEAD_STAGES = ['NEW', 'CONTACTED', 'TOUR_BOOKED', 'TRIAL', 'WON', 'LOST'] as const;
export type LeadStage = (typeof LEAD_STAGES)[number];

/** Stages a lead is still being worked in: follow-ups, reminders and the desk's matching only look at these. */
export const LEAD_OPEN_STAGES = ['NEW', 'CONTACTED', 'TOUR_BOOKED', 'TRIAL'] as const satisfies readonly LeadStage[];
export type LeadOpenStage = (typeof LEAD_OPEN_STAGES)[number];

export function isOpenLeadStage(stage: string): stage is LeadOpenStage {
  return (LEAD_OPEN_STAGES as readonly string[]).includes(stage);
}

export const LEAD_SOURCES = ['WEBSITE_FORM', 'WALK_IN', 'PHONE', 'REFERRAL', 'CAMPAIGN', 'SOCIAL', 'OTHER'] as const;
export type LeadSource = (typeof LEAD_SOURCES)[number];

/**
 * What a lead's timeline records. Every kind that moves the lead carries the stage it moved to: CREATED, STAGE_CHANGED,
 * and the two ways a lead becomes a member, CONVERTED (from the lead) and MATCHED (the desk added the same person).
 * APPOINTMENT is a tour or consultation booked for the lead, and how it went; booking one can move the stage too.
 */
export const LEAD_ACTIVITY_KINDS = ['CREATED', 'STAGE_CHANGED', 'NOTE', 'CALL', 'ASSIGNED', 'FOLLOW_UP', 'UPDATED', 'CONVERTED', 'MATCHED', 'APPOINTMENT'] as const;
export type LeadActivityKind = (typeof LEAD_ACTIVITY_KINDS)[number];

export const LEAD_APPOINTMENT_OUTCOMES = ['BOOKED', 'COMPLETED', 'NO_SHOW', 'CANCELLED'] as const;
export type LeadAppointmentOutcome = (typeof LEAD_APPOINTMENT_OUTCOMES)[number];

/** What staff write by hand on a lead's timeline. */
export const LEAD_NOTE_KINDS = ['NOTE', 'CALL'] as const satisfies readonly LeadActivityKind[];
export type LeadNoteKind = (typeof LEAD_NOTE_KINDS)[number];
